import type { LinkProps } from '@tanstack/react-router';

/**
 * TanStack Router の `to` は「登録済みルートパスのリテラル union」で、
 * `string` をそのまま渡すと型エラーになる。
 *
 * ナビ定義（`lib/nav.ts`）や API が返すアラートの `href` は**データとして**扱いたいので、
 * ここ 1 か所だけ型を緩める。実在するパスかどうかは
 * 「nav.ts の href と router.tsx のパスを揃える」ことで担保する
 * （存在しないパスを渡すと NotFound 画面が出るので、壊れれば必ず気付ける）。
 */
export function navTo(href: string): LinkProps['to'] {
  return href as LinkProps['to'];
}
